import { AvatarStack, Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import buildUrl from 'modules/core/lib/buildUrl'

import { TaskAssignee } from 'modules/tasks/components/TasksList/types'

interface AssigneesProps {
  assignees: TaskAssignee[]
  count?: number
}

const AssigneesList = ({ assignees, count }: AssigneesProps) => {
  if (assignees.length === 0) return null

  return (
    <Box alignItems="center" flexDirection="row">
      <AssigneesStack assignees={assignees} count={count} />
    </Box>
  )
}

const AssigneesStack = ({ assignees, count: totalCount }: AssigneesProps) => {
  const assigneesLimit = 3
  const countLimit = 99
  const count = (totalCount || assignees.length) - assigneesLimit
  const itemAvatars = assignees.map((assignee) => ({
    label: assignee.fullName,
    url: buildUrl(assignee.avatar ?? ''),
  }))

  const leftover = Math.min(count, countLimit)

  const avatars = itemAvatars.slice(0, assigneesLimit)

  return (
    <AvatarStack
      size="s32"
      overlap="s8"
      textColor="viridian1000"
      textSize="100"
      backgroundColor="viridian200"
      avatars={avatars}
      leftover={leftover}
    />
  )
}

export default observer(AssigneesList)
